
import FormBaseLayout from "../../components/FormBaseLayout";

import { useResumenJornada } from "./useResumenJornada";

import styleLocal from "./ResumenJornadaLayout.module.css";


import styleRegistro from "../registroPosicion/RegistroPosicionLayout.module.css";

import IconFumigadora from "../../components_svg/IconFumigadora";

import { useAuthStore } from "../login/hooks/useAuthStore";

import { sincronizarRegistrosPendientes } from "../../services/indexedbd/sincronizacionActions";

import stylesLogout from "../login/LoginLayout.module.css";

import { URL_API_BACKEND } from "../../data/finca/info";

const ResumenJornadaLayout = () => {
  const { registrados, revisados, refrescar } = useResumenJornada();

  const handleRefrescar = async () => {
    try{
      return await sincronizarRegistrosPendientes();
    } catch (error){
      console.error("Error al refrescar la jornada:", error);
      throw error;
    } finally{
      refrescar();
    }
  };



  const nombreUsuarioStore = useAuthStore((state) => state.nombreUsuario);
  const tokenStore = useAuthStore((state) => state.token);
  const logoutStore = useAuthStore((state) => state.logout);

  const nombreUsuario = (nombreUsuarioStore || "USUARIO").toUpperCase();

  const handleLogout = async () => {
    try {
      await fetch(`${URL_API_BACKEND}/usuarios/logout`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${tokenStore}`,
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.error("Error al revocar sesión en servidor:", error);
    } finally {
      // Independientemente de si el servidor responde o no, limpiamos 
      // el Store localmente. Al hacerlo, la vista cambiará al Login de inmediato.
      logoutStore();
    }
  };

  return (
    <FormBaseLayout
      buttonText="Sincronizar datos"
      onExecute={handleRefrescar}>

      <div className={styleLocal.headerUsuario}>
        <p className={styleLocal.textoBienvenida}>
          HOLA {nombreUsuario}
        </p>
        <button 
          type="button" 
          className={stylesLogout.btnCerrarSesion} 
          onClick={handleLogout}
        >
          Cerrar Sesión
        </button>
      </div>

      
      <section className={styleRegistro.contenedorLogo}>
                <figure>
                    <IconFumigadora width={80} height={80} />
                </figure>
                
                <h3 className={styleLocal.titulo}>
                    RESUMEN DE REGISTROS HOY
                </h3>
                
            </section>

      {/* 2. Reemplazamos todos los Box y Typography de MUI por etiquetas HTML semánticas */}
      <aside className={styleRegistro.contenedorLogo}>
        
        
        
          <div className={styleLocal.columnaConteo}>

            <div className={styleLocal.ContenedorEtiquetaCorta}>
              <p className={styleLocal.etiquetaCorta}>PALMAS</p>
              <p className={styleLocal.etiquetaCorta}>MARCADAS</p>
            </div>

            <h3 className={styleLocal.numeroGrande}>{registrados}</h3>
          </div>
          
          <div className={styleLocal.columnaConteo}>

            <div className={styleLocal.ContenedorEtiquetaCorta}>
              <p className={styleLocal.etiquetaCorta}>PALMAS</p>
              <p className={styleLocal.etiquetaCorta}>REVISADAS</p>
            </div>

            <h3 className={`${styleLocal.numeroGrande} ${styleLocal.numeroRevisados}`}>
              {revisados}
            </h3>
          </div>
        

      </aside>
    </FormBaseLayout>
  );
};

export default ResumenJornadaLayout;